import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';
import { FiRefreshCcw, FiZap, FiAward } from 'react-icons/fi';
import { Footer } from '../components/Footer';

export const ChallengeResult = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { creatorName, challengerName, score, total } = location.state || {};

  const logoUrl = "https://media-manager-c.questera.ai/greta-media/5aef0a8df517b865df3c53c45a2fd1ff726cf5f808670b49edd6820a48780cae68c41714c5c531fe697e77aede0c0572/images/aW1hZ2UvcG5n/b4fb7c8e8b2fa91d7665d00ad27aec75.png";

  if (score === undefined) return <div className="p-6 text-white text-center">No result found.</div>;

  const percentage = (score / total) * 100;
  let message = "";
  let colorClass = "";

  if (percentage >= 80) {
    message = "Bestie Status Confirmed 👑";
    colorClass = "text-[#d2ff02]";
  } else if (percentage >= 50) {
    message = "You know them... mostly. 👀";
    colorClass = "text-[#0094f7]";
  } else {
    message = "Do you even know who this is? 💀";
    colorClass = "text-red-400";
  }

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden bg-[#012b58]">
      <div className={`absolute inset-0 opacity-20 pointer-events-none ${percentage >= 50 ? 'bg-[radial-gradient(circle_at_center,_#0094f7,_transparent)]' : 'bg-[radial-gradient(circle_at_center,_#ff4444,_transparent)]'}`} />
      
      <div className="flex-1 flex flex-col items-center justify-center p-6 z-10">
        <motion.div 
          initial={{ scale: 0.9, opacity: 0 }} 
          animate={{ scale: 1, opacity: 1 }} 
          className="w-full max-w-md text-center"
        >
          <div className="mb-8 flex justify-center">
            <img src={logoUrl} alt="Logo" className="h-16 w-auto object-contain" />
          </div>

          <div className="glass-panel p-8 rounded-[2.5rem] relative overflow-hidden mb-8 border border-white/10 shadow-2xl">
            <div className="w-16 h-16 bg-white/5 rounded-full flex items-center justify-center mx-auto mb-6">
               <SafeIcon icon={FiAward} className={`text-3xl ${colorClass}`} />
            </div>
            <h2 className="text-xl font-medium text-slate-300 mb-6 uppercase tracking-widest">
              {challengerName}'s Score
            </h2>
            <div className="flex justify-center items-end gap-2 mb-4">
              <span className={`text-8xl font-black ${colorClass} drop-shadow-[0_0_20px_rgba(210,255,2,0.2)]`}>{score}</span>
              <span className="text-3xl text-slate-500 font-bold mb-3">/{total}</span>
            </div>
            <p className="text-2xl font-bold text-white mb-2">{message}</p>
          </div>

          <div className="bg-[#012b58]/80 border border-[#0094f7]/30 p-8 rounded-[2.5rem] shadow-[0_0_30px_rgba(0,148,247,0.1)]">
            <div className="w-12 h-12 bg-[#d2ff02]/20 rounded-full flex items-center justify-center mx-auto mb-4 text-[#d2ff02] text-xl">
              <SafeIcon icon={FiZap} />
            </div>
            <h3 className="text-2xl font-bold mb-2 text-white">Think you can do better?</h3>
            <p className="text-slate-300 text-sm mb-8 leading-relaxed">
              Turn the tables. Create your own quiz and see if {creatorName} actually knows YOU.
            </p>
            <Button onClick={() => navigate('/')} className="w-full text-lg h-14">
              Create My Quiz <SafeIcon icon={FiRefreshCcw} />
            </Button>
          </div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
};